import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.85);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-136">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-0 left-0 right-0 z-50 md:hidden" data-id="element-137">
          <div className="bg-black/95 backdrop-blur-sm border-t border-gold/20 px-4 py-3" data-id="element-138">
            <a href="https://tutiendadigi.shop/cart/51868811428120:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="block w-full py-4 bg-gold text-black font-sans font-semibold text-xs tracking-[0.15em] uppercase text-center" data-id="element-139">
              LO QUIERO
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}